import { render, staticRenderFns } from "./dynamicUser.vue?vue&type=template&id=27e72651&scoped=true&"
import script from "./dynamicUser.vue?vue&type=script&lang=js&"
export * from "./dynamicUser.vue?vue&type=script&lang=js&"
import style0 from "./dynamicUser.vue?vue&type=style&index=0&id=27e72651&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e72651",
  null
  
)

export default component.exports